import Swup from 'swup'
import SwupHeadPlugin from '@swup/head-plugin'
import SwupA11yPlugin from '@swup/a11y-plugin'
import SwupBodyClassPlugin from '@swup/body-class-plugin'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default class Transitions {
	static defaults = { container: '#swup', duration: 0.4, onPageView: null }

	constructor(options = {}) {
		if (Transitions.instance) return Transitions.instance

		this.options = { ...Transitions.defaults, ...options }
		this.#init()

		Transitions.instance = this
	}

	#init() {
		this.swup = new Swup({
			containers: [this.options.container],
			animationSelector: false,
			linkToSelf: 'navigate',
			native: false,
			plugins: [
				new SwupHeadPlugin({ persistAssets: true }),
				new SwupA11yPlugin(),
				new SwupBodyClassPlugin({ attributes: ['data-template'] }),
			],
			ignoreVisit: url => this.#shouldIgnore(url),
		})

		this.#registerAnimations()
		this.#registerHooks()
	}

	#shouldIgnore(url) {
		return /(\/wp-admin|\/wp-login\.php|\/wp-content\/uploads|\/feed\/?$|\.(pdf|zip|jpe?g|png|webp|mp4)$)/i.test(url)
	}

	#registerAnimations() {
		this.swup.hooks.replace('animation:out:await', async () => {
			await gsap.to(this.options.container, {
				opacity: 0,
				duration: this.options.duration,
				ease: 'power2.out',
			})
		})

		this.swup.hooks.replace('animation:in:await', async () => {
			await gsap.fromTo(
				this.options.container,
				{ opacity: 0 },
				{ opacity: 1, duration: this.options.duration, ease: 'power2.out' }
			)
		})
	}

	#registerHooks() {
		this.swup.hooks.on('content:replace', () => {
			ScrollTrigger.getAll().forEach(trigger => trigger.kill())
		})

		this.swup.hooks.on('page:view', (visit, { url, title }) => {
			this.options.onPageView?.({ url, title, container: document.querySelector(this.options.container) })
			ScrollTrigger.refresh()
		})
	}

	on(hook, callback) {
		this.swup.hooks.on(hook, callback)
	}

	dispose() {
		this.swup?.destroy()
		this.swup = null
		Transitions.instance = null
	}
}
